.Fader {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    user-select: none;
    touch-action: none;

    &.isClipping {
        & .Fader__fill {
            background: var(--soniq-t--global--background--color--status--warning--strong);
        }

        & .Fader__value {
            color: var(--soniq-t--global--text--color--status--warning--default);
        }
    }
}

.Fader__stage {
    display: flex;
    gap: 10px;
    height: 190px;
}

.Fader__legend {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: var(--soniq-t--global--font--family--mono);
    font-size: 9px;
    color: var(--soniq-t--global--text--color--secondary--default);
    text-align: right;
    padding: 2px 0;
}

.Fader__slot {
    position: relative;
    width: 34px;
    border-radius: 8px;
    background: var(--soniq-t--global--background--color--surface--panel-subtle);
    border: 1px solid var(--soniq-t--global--border--color--input--default);
    cursor: ns-resize;

    &:focus-visible {
        outline: 2px solid var(--soniq-t--global--border--color--accent--today--default);
        outline-offset: 3px;
    }
}

.Fader__groove {
    position: absolute;
    top: 10px;
    bottom: 10px;
    left: calc(50% - 2px);
    width: 4px;
    border-radius: 2px;
    background: var(--soniq-t--global--background--color--surface--input);
}

.Fader__fill {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-radius: 2px;
    background: var(--soniq-t--global--palette--hot-pink);
    opacity: 0.9;
}

.Fader__thumb {
    position: absolute;
    left: 3px;
    right: 3px;
    height: 22px;
    transform: translateY(-50%);
    border-radius: 5px;
    background: linear-gradient(180deg, var(--soniq-t--global--background--color--surface--hover), transparent),
    var(--soniq-t--global--background--color--surface--panel-opaque);
    border: 1px solid var(--soniq-t--global--border--color--event--opaque);
    box-shadow: 0 4px 10px var(--soniq-t--global--text--shadow--subtle);

    &::after {
        content: "";
        position: absolute;
        left: 4px;
        right: 4px;
        top: calc(50% - 1px);
        height: 2px;
        background: var(--soniq-t--global--palette--hot-pink);
        border-radius: 1px;
    }
}

.Fader__label {
    font-size: var(--soniq-t--global--font--size--field-label);
    font-weight: var(--soniq-t--global--font--weight--medium);
    letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
    text-transform: uppercase;
    color: var(--soniq-t--global--text--color--label--default);
}

.Fader__value {
    font-family: var(--soniq-t--global--font--family--mono);
    font-size: var(--soniq-t--global--font--size--date);
    color: var(--soniq-t--global--text--color--primary--default);
    background: var(--soniq-t--global--background--color--surface--input);
    border: 1px solid var(--soniq-t--global--border--color--input--default);
    border-radius: 6px;
    padding: 2px 8px;
    min-width: 72px;
    text-align: center;
}
